<app-navbar></app-navbar>

  
  <div class="dashboard-full-width">
    <div class="">
      <div class="main-container-dashboard">
  
  
        <!-- <app-lab-sidebar></app-lab-sidebar> -->
      
        
  
  
        <div class="dashboard-container-right">
  
          <div class="main-container">

            <div class="row">
              <div class="col-lg-12">
          
                      <div class="dashboard-banner-box mb-3" style="margin-right: 0px;">
                        <div class="dashboard-heading">
                          <h2>Welcome to Laboratory Admin Dashboard</h2>
                          <p>Lorem Ipsum is simply dummy text of the printing.</p>
                        </div>
                        <div class="search-box">
                          
                          <input type="text" placeholder="Enter Passport number to search result ..." class="search-box-dashboard search-icon">
                          
                          <button class="search-button">Search</button>
                        </div>
                        
                      </div>

              </div>
            </div>
  
            <div class="row">

              <div class="col-lg-4">
                    <div class="row">
                    <div class="col-lg-12">
                      <div class="dashboard-box">

                        <div class="box-icon">
                          <i class="far fa-calendar-check"></i>
                        </div>

                        <div class="box-text">
                            <div class="number">3,22,0020</div>
                            <div class="small-text">Total Appointments</div>
                            <a href="javascript:void(0);" class="view-more-box-link">View More &nbsp; <i class="fas fa-external-link-alt"></i></a>
                        </div>
                        
                      </div>
                    </div>
                    <div class="col-lg-12 mt-4 mb-3">
                      <div class="dashboard-box">

                        <div class="box-icon">
                          <i class="fas fa-vials"></i>
                        </div>

                        <div class="box-text">
                          <div class="number">16,28,000</div>
                          <div class="small-text">Logged Samples</div>
                          <a href="javascript:void(0);" class="view-more-box-link">View More &nbsp; <i class="fas fa-external-link-alt"></i></a>
                        </div>

                     


                      </div>
                    </div>
                    <div class="col-lg-12  mt-4">
                      <div class="dashboard-box">

                        <div class="box-icon">
                          <i class="fas fa-hand-holding-usd"></i>
                        </div>

                        <div class="box-text">
                         
                          <div class="number">6,23,000</div>
                          <div class="small-text">Total Payments</div>
                          <a href="javascript:void(0);" class="view-more-box-link">View More &nbsp; <i class="fas fa-external-link-alt"></i></a>
                       </div>

                      </div>
                    </div>
                    </div>
                    
                    <!-- <div class="col-lg-12">
                      <div class="dashboard-box">
                        <div class="box-icon">
                          <i class="fas fa-bullhorn"></i>
                        </div>
                        <div class="box-text">
                            <div class="number">66,99,00</div>
                            <div class="small-text">Contrary to popular belief</div>
                            <a href="#" class="view-more-box-link">View More <i class="fas fa-external-link-alt"></i></a>
                        </div>
                      </div>
                    </div> -->
              </div>

            <div class="col-lg-4 col-md-6 mt_less_320_15">
               
                
                <div class="card h-100">
                  <!-- Header -->
                  <div class="card-header-bg">
                    <div class="card-heading">
                        <h4>Report</h4>
                    </div>
                    <div class="cart-header-input">
                        <select class="header-input-type">
                          <option>Small select</option>
                        </select>
                    </div>
                    <!-- End Unfold -->
                  </div>
                  <!-- End Header -->
    
                  <!-- Body -->
                  <div class="">

                      <img src="assets/image/graph-1.png" class="img-fluid">

                   <!-- <ul class="list-group list-group-flush list-group-no-gutters">
                      <li class="list-group-item py-3">
                      </li>
                   </ul> -->


                  </div>
                  <!-- End Body -->
                </div>


              </div>





              <div class="col-lg-4  col-md-6  mt_less_320_15">
               
                
                <div class="card h-100">
                  <!-- Header -->
                  <div class="card-header-bg">
                    <div class="card-heading">
                        <h4>Logged Samples</h4>
                    </div>
                    <div class="cart-header-input">
                        <select class="header-input-type">
                          <option>Small select</option>
                        </select>
                    </div>
                    <!-- End Unfold -->
                  </div>
                  <!-- End Header -->
    
                  <!-- Body -->
                  <div class="">

                    <img src="assets/image/graph-2.png" class="img-fluid">

                   <!-- <ul class="list-group list-group-flush list-group-no-gutters">
                      <li class="list-group-item py-3">
                      </li>
                   </ul> -->


                  </div>
                  <!-- End Body -->
                </div>
                

              </div>




              <div class="col-lg-8 mt-3  col-md-6 mt_less_320_15">
                <div class="row">
                <div class="col-lg-12">
                  
                  <div class="card h-100">
                    <!-- Header -->
                    <div class="card-header-bg">
                      <div class="card-heading">
                          <h4>List of Logged Samples</h4>
                      </div>
                      <div class="cart-header-input">
                          <select class="header-input-type">
                            <option>Small select</option>
                          </select>
                      </div>
                      <!-- End Unfold -->
                    </div>
                    <!-- End Header -->
      
                    <!-- Body -->
                    <div class="table-responsive">
  
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th scope="col">Sr.No.</th>
                            <th scope="col">Appointment ID</th>
                            <th scope="col">F.Name</th>
                            <th scope="col">L.Name</th>
                            <th scope="col">Passport Number </th>
                            <th scope="col">Phone No.  </th>
                            <th scope="col">Sample Collection Center   </th>
                            <th scope="col">Payment</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td scope="row">1</td>
                            <td>INB71380456D</td>
                            <td>Yatender </td>
                            <td>Pundir</td>
                            <td>HS213333JS3331            </td>
                            <td>98979 18753             </td>
                            <td>Manish Collection Center</td>
                            <td><i class="fas fa-check-circle green"></i></td>
                          </tr>
                          <tr>
                            <td scope="row">2</td>
                            <td>INB71380456D</td>
                            <td>Yatender </td>
                            <td>Pundir</td>
                            <td>HS213333JS3331</td>
                            <td>98979 18753</td>
                            <td>Manish Collection Center</td>
                            <td><i class="fas fa-times-circle red"></i></td>
                          </tr>
                          <tr>
                            
                              <td scope="row">3</td>
                              <td>INB71380456D</td>
                              <td>Yatender </td>
                              <td>Pundir</td>
                              <td>HS213333JS3331            </td>
                              <td>98979 18753             </td>
                              <td>Manish Collection Center</td>
                              <td><i class="fas fa-times-circle red"></i></td>
                            
                          </tr>
                          <tr>
                         
                              <td scope="row">4</td>
                              <td>INB71380456D</td>
                              <td>Yatender </td>
                              <td>Pundir</td>
                              <td>HS213333JS3331            </td>
                              <td>98979 18753             </td>
                              <td>Manish Collection Center</td>
                              <td><i class="fas fa-check-circle green"></i></td>
                           
                          </tr>   
                          
                          <tr>
                         
                            <td scope="row">5</td>
                            <td>INB71380456D</td>
                            <td>Yatender </td>
                            <td>Pundir</td>
                            <td>HS213333JS3331            </td>
                            <td>98979 18753             </td>
                            <td>Manish Collection Center</td>
                            <td><i class="fas fa-check-circle green"></i></td>
                         
                        </tr> 

                        <tr>
                         
                          <td scope="row">6</td>
                          <td>INB71380456D</td>
                          <td>Yatender </td>
                          <td>Pundir</td>
                          <td>HS213333JS3331            </td>
                          <td>98979 18753             </td>
                          <td>Manish Collection Center</td>
                          <td><i class="fas fa-check-circle green"></i></td>
                       
                      </tr> 
                        </tbody>
                      </table>
  
  
                    </div>
                    <!-- End Body -->
                  </div>


                </div>
                </div>
              </div>

              <div class="col-lg-4  col-md-6 mt-3">
               
                
                <div class="card h-100">
                  <!-- Header -->
                  <div class="card-header-bg">
                    <div class="card-heading">
                        <h4>Arriving or Departing EG</h4>
                    </div>
                    <div class="cart-header-input">
                        <select class="header-input-type">
                          <option>Arriving</option>
                        </select>
                    </div>
                    <!-- End Unfold -->
                  </div>
                  <!-- End Header -->
    
                  <!-- Body -->
                  <div class="">
                    <ul class="list-group list-group-flush list-group-no-gutters">

                      <li class="list-group-item-cus">
                        <div class="detail-1">
                          <div class="passanger-name">Santosh Pandey</div>
                          <div class="traveling-destination">India > Dubai > Nigeria</div>
                          <div class="date-time">Date: 16.07.2021  Time: 11:00am</div>
                        </div>
                        <div class="detail-2">
                          <div class="passport-no">PN: CXUS9303HHD83</div>
                          <a class="view-more-box-link" href="javascript:void(0);">View More &nbsp;<i class="fas fa-external-link-alt"></i></a>
                        </div>
                      </li>

                      <li class="list-group-item-cus">
                        <div class="detail-1">
                          <div class="passanger-name">Santosh Pandey</div>
                          <div class="traveling-destination">India > Dubai > Nigeria</div>
                          <div class="date-time">Date: 16.07.2021  Time: 11:00am</div>
                        </div>
                        <div class="detail-2">
                          <div class="passport-no">PN: CXUS9303HHD83</div>
                          <a class="view-more-box-link" href="javascript:void(0);">View More &nbsp;<i class="fas fa-external-link-alt"></i></a>
                        </div>
                      </li>

                      <li class="list-group-item-cus">
                        <div class="detail-1">
                          <div class="passanger-name">Santosh Pandey</div>
                          <div class="traveling-destination">India > Dubai > Nigeria</div>
                          <div class="date-time">Date: 16.07.2021  Time: 11:00am</div>
                        </div>
                        <div class="detail-2">
                          <div class="passport-no">PN: CXUS9303HHD83</div>
                          <a class="view-more-box-link" href="javascript:void(0);">View More &nbsp;<i class="fas fa-external-link-alt"></i></a>
                        </div>
                      </li>
                      <li class="list-group-item-cus">
                        <div class="detail-1">
                          <div class="passanger-name">Santosh Pandey</div>
                          <div class="traveling-destination">India > Dubai > Nigeria</div>
                          <div class="date-time">Date: 16.07.2021  Time: 11:00am</div>
                        </div>
                        <div class="detail-2">
                          <div class="passport-no">PN: CXUS9303HHD83</div>
                          <a class="view-more-box-link" href="javascript:void(0);">View More &nbsp;<i class="fas fa-external-link-alt"></i></a>
                        </div>
                      </li>


                    </ul>
                  </div>
                  <!-- End Body -->
                </div>


              </div>

              

            </div>
            

            

            




  
  
          </div>
  
        </div>
  
      </div>
    </div>
  </div>



  <app-footer-dashboard></app-footer-dashboard>